export const GET_ALL_MAINTENANCE_PLANS = "GET_ALL_MAINTENANCE_PLANS";

export const getAllMaintenancePlans = (data) => {
    return {
        type: GET_ALL_MAINTENANCE_PLANS,
        payload: data
    }
};
